// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"abb7e7a1","452":"ce9961e0","487":"fcec59d9","649":"0829a099","744":"64fd31b6"}[chunkId] + ".chunk.js";
};